import { gsap } from 'gsap';

const selectContent = (category) => {
    // deselect btn(s)
    // handle duplicates when slider is looped
    const selectedBtns = document.querySelectorAll('.js-dial-btn.is-selected');
    if (selectedBtns.length > 0) {
        selectedBtns.forEach((selectedBtn) => {
            selectedBtn.classList.remove('is-selected');

            // hide segment
            gsap.set(document.querySelector(`.js-dial-segment[data-category=${selectedBtn.dataset.category}]`), {
                display: 'none',
            });
        });
    }

    // select btn(s)
    // handle duplicates when slider is looped
    const targetBtns = document.querySelectorAll(`.js-dial-btn[data-category=${category}]`);
    targetBtns.forEach((targetBtn) => {
        targetBtn.classList.add('is-selected');
    });

    // assign selected option
    const selectInput = document.querySelector('.js-dial-select');
    selectInput.value = category;

    // show segment
    gsap.set(document.querySelector(`.js-dial-segment[data-category=${category}]`), {
        display: 'block',
    });
};

export default selectContent;
